import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Suspense as _Suspense, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flash flash-permanent"
}
const _hoisted_2 = {
  key: 2,
  class: "flash flash-permanent"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Chargement... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Flashes = _resolveComponent("Flashes")!
  const _component_Dialogs = _resolveComponent("Dialogs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.user)
      ? (_openBlock(), _createBlock(_component_Nav, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.connectedAs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Connecté en tant que " + _toDisplayString(_ctx.user?.first_name) + " " + _toDisplayString(_ctx.user?.last_name), 1))
      : _createCommentVNode("", true),
    (_ctx.isIntegrationEnv)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Environnement de test "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "app-container",
      style: _normalizeStyle(`margin-left: ${_ctx.appOffset}`)
    }, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        fallback: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }))
    ], 4),
    (_ctx.modalFormProps)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalFormProps = undefined)),
          onExit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalFormProps = undefined)),
          cancel: { text: 'Annuler' },
          confirm: null
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Form, _mergeProps(_ctx.modalFormProps, {
              onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRelationAdded()))
            }), null, 16)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Flashes),
    _createVNode(_component_Dialogs)
  ], 64))
}